import React from "react";
const Error = () => {
  return (
    <div className="section section-center text-center">
      <h4>Sorry, There was an error...</h4>
    </div>
  );
};

export default Error;
